import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class TaskAttachmentRepositoryService extends BaseRepositoryService<
  ModelRegistry['task-attachment']
> {
  recordName = 'task-attachment';
  implementMethods = ['createRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/task-attachment': TaskAttachmentRepositoryService;
  }
}
